import React, { useState, useEffect } from "react";
import axios from "axios";
import Coin from "./Coin";
import "./App.css";
function App() {
  const [coins, setCoins] = useState([]);
  const [mode, setMode] = useState("true");
  const [search, setSearch] = useState("");
  const Api =
    "https://api.coingecko.com/api/v3/coins/markets?vs_currency=inr&order=market_cap_desc&per_page=10&page=1&sparkline=false";

  useEffect(() => {
    axios
      .get(Api)
      .then((res) => setCoins(res.data))
      .catch((err) => console.log(err));
  }, []);
  console.log(coins.data);
  const handleChange = (e) => {
    setSearch(e.target.value);
  };

  const filteredCoins = coins.filter((coin) =>
    coin.name.toLowerCase().includes(search.toLowerCase())
  );

  console.log(filteredCoins);
  return (
    <div className="coin-app">
      <div className="coin-search">
        <h1 className="coin-text">Search for coins</h1>
        <form>
          <input
            type="text"
            placeholder="Enter coin name"
            className="coin-input"
            onChange={handleChange}
          />
        </form>
      </div>
      {filteredCoins.map((coin) => {
        return (
          <Coin
            key={coin.id}
            name={coin.name}
            image={coin.image}
            volume={coin.market_cap}
            symbol={coin.symbol}
            price={coin.current_price}
            priceChange={coin.price_change_percentage_24h}
          />
        );
      })}
      <p style={{ marginTop: "12px", marginBottom: "20px" }}>
        Made with 💙 by{" "}
        <a href="https://pragyan2000.github.io/portfolio/">
          Pragyan yaduvanshi
        </a>
      </p>
    </div>
  );
}
export default App;
